import { css } from '@emotion/react';
import { LayoutComponent } from './Layout';
import { GlobalComponent } from './Global';

/** Global styles injected once at app root — component/page styles live in local imports */
export const AppStyles = css`
  ${LayoutComponent}
  ${GlobalComponent}
`;
